export enum LiveSportsTabs {
    Favourites = "Favourites",
    Streams = "Streams",
    OtherSports = "OtherSports",
}
